import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../API/EndPoints";
import AxiosInstance from "../API/AxiosInstance";

// ------------------ THUNKS ------------------
export const sendOtp = createAsyncThunk(
  "login/sendOtp",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.SEND_OTP,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const verifyOtp = createAsyncThunk(
  "login/verifyOtp",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.VERIFY_OTP,
        credentials
      );
      if (response.data.status === false) {
        return rejectWithValue(response.data.message);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const createPassword = createAsyncThunk(
  "login/createPassword",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.SET_PASSWORD,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const createAccount = createAsyncThunk(
  "login/createAccount",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.CREATE_ACCOUNT,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const loginUser = createAsyncThunk(
  "login/loginUser",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.LOGIN_USER,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

// ------------------ INITIAL STATE ------------------
const initialState = {
  sendOtp: {
    loading: false,
    error: null,
    data: null,
  },
  verifyOtp: {
    loading: false,
    error: null,
    data: null,
  },
  createPassword: {
    loading: false,
    error: null,
    data: null,
  },
  createAccount: {
    loading: false,
    error: null,
    data: null,
  },
  loginUser: {
    loading: false,
    error: null,
    data: null,
  },
};

// ------------------ SLICE ------------------
const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // SEND OTP
    builder
      .addCase(sendOtp.pending, (state) => {
        state.sendOtp.loading = true;
        state.sendOtp.error = null;
      })
      .addCase(sendOtp.fulfilled, (state, action) => {
        state.sendOtp.loading = false;
        state.sendOtp.data = action.payload;
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.sendOtp.loading = false;
        state.sendOtp.error = action.payload;
      });

    // VERIFY OTP
    builder
      .addCase(verifyOtp.pending, (state) => {
        state.verifyOtp.loading = true;
        state.verifyOtp.error = null;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.verifyOtp.loading = false;
        state.verifyOtp.data = action.payload;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.verifyOtp.loading = false;
        state.verifyOtp.error = action.payload;
      });

    // CREATE PASSWORD
    builder
      .addCase(createPassword.pending, (state) => {
        state.createPassword.loading = true;
        state.createPassword.error = null;
      })
      .addCase(createPassword.fulfilled, (state, action) => {
        state.createPassword.loading = false;
        state.createPassword.data = action.payload;
      })
      .addCase(createPassword.rejected, (state, action) => {
        state.createPassword.loading = false;
        state.createPassword.error = action.payload;
      });

    // CREATE ACCOUNT
    builder
      .addCase(createAccount.pending, (state) => {
        state.createAccount.loading = true;
        state.createAccount.error = null;
      })
      .addCase(createAccount.fulfilled, (state, action) => {
        state.createAccount.loading = false;
        state.createAccount.data = action.payload;
      })
      .addCase(createAccount.rejected, (state, action) => {
        state.createAccount.loading = false;
        state.createAccount.error = action.payload;
      });

    // LOGIN USER
    builder
      .addCase(loginUser.pending, (state) => {
        state.loginUser.loading = true;
        state.loginUser.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loginUser.loading = false;
        state.loginUser.data = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loginUser.loading = false;
        state.loginUser.error = action.payload;
      });
  },
});

export default loginSlice.reducer;
